import { add, set } from '@/vuex/helpers';

export default {
  namespaced: true,
  state: {
    permits: [],
    permit: null,
    statuses: [],
    documents: [],
    document: null,

    documentStatuses: [
      {
        id: 10,
        value: 'Missing',
        color: 'primary',
        key: 'foreigners.permits.documents.statuses.missing',
      },
      {
        id: 20,
        value: 'Waiting for review',
        color: 'warning',
        key: 'foreigners.permits.documents.statuses.waiting',
      },
      {
        id: 30,
        value: 'Accepted',
        color: 'success',
        key: 'foreigners.permits.documents.statuses.accepted',
      },
    ],
  },
  mutations: {
    set,
    add,
  },
  actions: {
    async load({ commit }, foreignerId) {
      const permits = await this.$axios.$get(`/api_foreigner/${foreignerId}/permit/`);
      commit('set', ['permits', permits]);
    },

    async loadPermit({ commit }, { foreignerId, permitId }) {
      const permit = await this.$axios.$get(`/api_foreigner/${foreignerId}/permit/${permitId}/`);
      commit('set', ['permit', permit]);
    },

    async loadStatuses({ commit }, permitId) {
      const statuses = await this.$axios.$get(`/api_foreigner/permit/${permitId}/status/`);
      commit('set', ['statuses', statuses]);
    },

    async loadDocuments({ commit }, permitId) {
      const documents = await this.$axios.$get(`/api_foreigner/permit/${permitId}/document/`);
      commit('set', ['documents', documents]);
    },

    async loadDocument({ commit }, documentId) {
      const doc = await this.$axios.$get(`/api_foreigner/permit/document/${documentId}/`);
      commit('set', ['document', doc]);
    },

    async uploadDocument({ commit }, { permitId, documentId, documents }) {
      const formData = new FormData();
      documents.forEach((document, i) => {
        const suffix = i === 0 ? '' : `_${i + 1}`;
        formData.append('document_name' + suffix, document.name);
        formData.append('document' + suffix, document);
      });

      const response = await this.$axios({
        method: 'patch',
        url: `/api_foreigner/permit/${permitId}/document/${documentId}/`,
        data: formData,
        config: {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        },
      }).catch((error) => {
        this._vm.$message.error({
          message: 'Error',
          showClose: true,
        });
      });

      this.permit = response.data.data;
    },
  },
};
